import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import ManageRolesForUsersContent from '../components/pages/org-unit/manage-users/manageRolesModal';

function ManageRolesForUsersModal(props) {
  const dispatch = useDispatch();
  const showManageRolesForOrgUsersModal = useSelector((state) => state.modalReducer.showManageRolesForOrgUsersModal);
  const manageRolesSelectedUserId = useSelector((state) => state.organisationsReducer.manageUsersPage.selectedUserId);
  const rolesForSelectedUser = useSelector((state) => state.organisationsReducer.manageUsersPage.rolesForSelectedUser);
  return (
    <div>
      <ManageRolesForUsersContent
        organisationalUnit={props.organisationalUnit}
        availableRoles={props.availableRoles}
        usersIcanManage={props.usersIcanManage}
        manageRolesSelectedUserId={manageRolesSelectedUserId}
        showManageRolesForOrgUsersModal={showManageRolesForOrgUsersModal}
        rolesForSelectedUser={rolesForSelectedUser}
        dispatch={dispatch}
      />
    </div>
  );
}

export default ManageRolesForUsersModal;
